<template>
  <transition name="fade" v-if=" $store.getLoading()[0]">
    <div class="overlayMain">
      <div class="loader-box">
        <div class="spinner"></div>
        <div class="loader-text">{{ $store.getLoading()[1] }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "GlobalLoader"
};
</script>

<style scoped>
/* TAM EKRAN OVERLAY */
.overlayMain {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(2px);
} 


/* ORTADAKİ KUTU */
.loader-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* SPINNER */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

/* ALTTAKİ MESAJ */
.loader-text {
  margin-top: 15px;
  color: #fff;
  font-size: 17px;
  font-weight: 500;
  text-align: center;
  text-shadow: 0 0 3px rgba(0,0,0,0.5);
}

/* SPINNER ANİMASYONU */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* FADE TRANSITION */
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/loader.vue